import React, { useState, useEffect } from "react";
import BoardCalendar from "../components/BoardCalendar";
import BoardWriteBox from "../components/BoardWriteBox";
import config from "../config/config";
const API_URL = config.API_URL;

function BoardPlan() {
  const currentDate = new Date();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editing, setEditing] = useState(false);   
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  
  const typeKey = "Plan";
  const typeKeyKor = "일정";

  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const [currentMonth, setCurrentMonth] = useState(
    formatDate(new Date(
      currentDate.getFullYear(), currentDate.getMonth(), 1
    ))
  );

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/get${typeKey}List`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body:JSON.stringify({
          currentMonth : currentMonth,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          _id: row._id || index + 1, // ID 설정
          id: index + 1,
          title : row.title || '-',          
          account : row.account || "-",
          start_date : row.start_date ? row.start_date.split("T")[0]: "-",
          end_date : row.end_date ? row.end_date.split("T")[0]: "-",
          monthly_report : row.monthly_report || 0,
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentMonth]);
  
  const handlePlanAdd = () =>{
    setSelectedId(null);
    setEditing(true)
    setIsModalOpen(true);
  }
  const handlePlanClick = (_id) =>{
    setSelectedId(_id);
    setEditing(false);
    setIsModalOpen(true);
  }

  const handleClose = (reload) =>{
    if(reload){
      fetchData();
    }
    setIsModalOpen(false);
  }

  const handlePrevMonth = () => {
    const dummyDate = new Date(currentMonth);
    const prevMonth = new Date(dummyDate.getFullYear(), dummyDate.getMonth() - 1, 1);
    setCurrentMonth(formatDate(prevMonth));
  };

  const handleNextMonth = () => {
    const dummyDate = new Date(currentMonth);
    const nextMonth = new Date(dummyDate.getFullYear(), dummyDate.getMonth() + 1, 1);
    setCurrentMonth(formatDate(nextMonth));
  };

  // const data =[
  //   {'start_date' : '2025-03-10', 'end_date': '2025-03-25', 'title': 'test2', "_id" : 1},
  //   {'start_date' : '2025-02-10', 'end_date': '2025-03-15', 'title': 'test3', "_id" : 2},
  //   {'start_date' : '2025-03-16', 'end_date': '2025-04-21', 'title': 'test4', "_id" : 3},
  //   {'start_date' : '2025-03-03', 'end_date': '2025-03-23', 'title': 'test5', "_id" : 4},
  // ];

  return (
    <div> 
      {loading ? (
        <p>Loading...</p>
      ):(
        <>
          <BoardCalendar handleNextMonth={handleNextMonth} handlePrevMonth={handlePrevMonth} data={data} currentMonth={currentMonth}
            handlePlanAdd={handlePlanAdd} handlePlanClick={handlePlanClick}/>
          {isModalOpen && (
            <BoardWriteBox boardTypeId={typeKey} boardTypeName={typeKeyKor} onClose={handleClose} boardId={selectedId} edit={editing}/>
          )}
        </>
      )}
    </div>
  );
}

export default BoardPlan;